module.exports = __webpack_public_path__ + "static/media/size.5889cc8d.svg";